import React, { ChangeEvent, FormEvent, useState } from 'react'
import { FC } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { get, ON_DEMAND_APIS } from 'src/apis/onDemandApi'
import { ListItem } from '../AbstractList/ListItem'
import { AbstractType } from '../PresentationContainer/PresentationContainer'
import { ResultModal, SearchStyle } from './styled'

interface AbstractSearchProps {
  submissionType: AbstractType['submission_type']
}

export const AbstractSearch: FC<AbstractSearchProps> = ({ submissionType }) => {
  const [query, setQuery] = useState('')
  const [result, setResult] = useState<Array<AbstractType> | null>(null)
  const [loading, setLoading] = useState(false)

  const clearResult = () => {
    setResult(null)
  }

  const getSearchResult = () => {
    setLoading(true)
    get(
      submissionType === 'poster' ? ON_DEMAND_APIS.POSTERS : ON_DEMAND_APIS.ORALS,
      (result) => {
        setLoading(false)
        if (result.success) {
          setResult(result.abstracts)
        } else {
          setResult([])
        }
      },
      (error) => {
        setLoading(false)
        toast.error('Unable to search, please try again.')
        console.error(error)
      },
      {
        search: query,
      }
    )
  }

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value)
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    getSearchResult()
  }

  const renderResult = () => {
    if (result.length) {
      return (
        <div className="">
          {result.map((abstract) => {
            return (
              <ListItem
                key={abstract.id}
                title={abstract.title}
                subtitle={abstract.presenting_author_name}
                abstractId={abstract.id}
                abstractType={abstract.submission_type}
              />
            )
          })}
        </div>
      )
    } else {
      return <p className="noResult">No matching results.</p>
    }
  }

  return (
    <SearchStyle>
      <form onSubmit={handleSubmit}>
        <input type="text" value={query} onChange={handleInput} placeholder="Search abstract by title..." />
        <input type="submit" value={loading ? 'Searching...' : 'Search'} disabled={loading || query.length < 2} />
      </form>

      {result && (
        <ResultModal show={result !== null} size="lg" centered onHide={clearResult}>
          <Modal.Header closeButton>
            Showing {result.length} results for "{query}":
          </Modal.Header>
          <Modal.Body>{renderResult()}</Modal.Body>
        </ResultModal>
      )}
    </SearchStyle>
  )
}
